function Footer() {
    return (
       <>
       {/* <!--Start footer area-->   */}
       <footer className="footer-area">
                        <div className="container">
                            <div className="row">
                                {/* <!--Start single footer widget--> */}
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="single-footer-widget mar-btm">
                                        <div className="footer-logo">
                                            <a href="/">
                                                <img src="assets/images/resources/logo.png" alt="FooterLogo"/>
                                            </a>
                                        </div>
                                          <div className="title">
                                            <h3>ISO 9001:2015</h3>
                                        </div>
                                        <div className="our-info">
                                            <p>
                                                Indus Refregeration Pvt LTD, is an Engineering, Procurement and Contracting company specialized in Industrial Refrigeration Engineering, Consulting and Erection & Commissioning of projects in Petrochemical, Pharmaceutical, Power plants ,Seafood & Meat, Fruits & Vegetables, Milk & Dairy, and Beverage industries.
                                            </p>
                                            <div className="button">
                                                <a href="/about-indusref"><span className="flaticon-arrows-1"></span>Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--End single footer widget--> */}
                                {/* <!--Start single footer widget--> */}
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="single-footer-widget mar-btm">
                                        <div className="title">
                                            <h3>Usefull Links</h3>
                                        </div>
                                        <ul className="usefull-links left">
                                            <li><a href="/">Home</a></li>
                                            <li><a href="/about-indusref">About Us</a></li>
                                            <li><a href="/indusref-products">Our Products</a></li>
                                            <li><a href="/indusref-markets">Markets</a></li>
                                            <li><a href="/indusref-partners">Partners</a></li>
                                            {/* <li><a href="/indusref-clients">Clients</a></li> */}
                                            <li><a href="/contact">Contact Us</a></li>
                                        </ul>
                                        <ul className="usefull-links">
                                            <li><a href="/industrial-refrigeration">Skid Mounted Refpacks</a></li>
                                                        <li><a href="/cooling-and-chilling">Cooling & Chilling Systems</a></li>
                                                        <li><a href="/heat-pumps">Heat Pumps</a></li>
                                                         <li><a href="/ICE-production-systems">ICE Production Systems</a></li>
                                                        <li><a href="/ammonia-recirculator-package">Ammonia Recirculator Package</a></li>
                                                        <li><a href="/cooling-condenser">Cooling Condenser</a></li>
                                                        <li><a href="/freezers">Freezers</a></li>
                                                        <li><a href="/pressure-vessels">Pressure Vessels</a></li>
                                                          <li><a href="/control-systems">Control Systems</a></li>
                                                        <li><a href="/support-services">Support Services</a></li>
                                        </ul>

                                          <ul className="usefull-links">
                                            <li><a href="/market-food">Food</a></li>
                                                        <li><a href="/market-dairy">Dairy</a></li>
                                                        <li><a href="/market-HVAC">Industrial HVAC</a></li>
                                                        <li><a href="/market-beverage">Beverage</a></li>
                                                        <li><a href="/market-pharma">Pharma</a></li>
                                                        <li><a href="/market-oil-gas-chemical">Oil / Gas / Chemical / Power </a></li>
                                                        <li><a href="/market-Cold-Storage-and-WareHouse">Cold Storage & WareHouse</a></li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!--Start single footer widget--> */}
                                {/* <!--Start single footer widget--> */}
                                {/* <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="single-footer-widget">
                                        <div className="title">
                                            <h3>Latest Installation</h3>
                                        </div>
                                        <ul className="instagram-feed-list">
                                            <li>
                                                <div className="image-holder">
                                                    <img src="assets/images/footer/instagram-1.webp" alt="Awesome Image"/>
                                                    <div className="overlay-style-one">
                                                        <div className="box">
                                                            <div className="content">
                                                                <a href="/project-single"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="image-holder">
                                                    <img src="assets/images/footer/instagram-2.webp" alt="Awesome Image"/>
                                                    <div className="overlay-style-one">
                                                        <div className="box">
                                                            <div className="content">
                                                                <a href="/project-single"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="image-holder">
                                                    <img src="assets/images/footer/instagram-3.webp" alt="Awesome Image"/>
                                                    <div className="overlay-style-one">
                                                        <div className="box">
                                                            <div className="content">
                                                                <a href="/project-single"><i className="fa fa-link" aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                           
                                        </ul>
                                    </div>
                                </div> */}
                                {/* <!--End single footer widget--> */}
                                {/* <!--Start single footer widget--> */}
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="single-footer-widget martop">
                                        <div className="title">
                                            <h3>Contact Details</h3>
                                        </div>
                                        <ul className="footer-contact-info">
                                            <li>
                                                <div className="icon-holder">
                                                    <span className="flaticon-pin map-marker"></span>
                                                </div>
                                                <div className="text-holder">
                                                    <h5><span>Address:</span> Plot No.6, V.R.B. Avenue,<br/> 
                                                    VRB Complex, First Floor(FA),<br/>  
                                                    DR. Kanu Nagar Main Rd, <br/> 
                                                    Nesapakkam, Chennai, <br/> 
                                                    India – 600078.</h5>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-holder">
                                                    <span className="flaticon-technology"></span>
                                                </div>
                                                <div className="text-holder">
                                                    <h5><span>Phone:</span> +91-9500651222/9600615574</h5>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-holder">
                                                    <span className="flaticon-interface"></span>
                                                </div>
                                                <div className="text-holder">
                                                    <h5><span>Email:</span> dirsales@indusref.com</h5>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="icon-holder">
                                                    <span className="flaticon-clock"></span>
                                                </div>
                                                <div className="text-holder">
                                                    <h5><span>Off Hrs:</span> Mon-Sat: 9am to 6pm</h5>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <!--End single footer widget--> */}
                            </div>
                        </div>
                    </footer>   
                    {/* <!--End footer area--> */}

                    {/* <!--Start footer bottom area-->  */}
                    <section className="footer-bottom-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="footer-bottom">
                                        <div className="copyright-text pull-left">
                                            <p>Copyrights © All Rights Reserved by <a href="/">Indus Refregeration Pvt LTD.</a></p> 
                                        </div>
                                        {/* <div className="footer-social-links pull-right">
                                            <ul>
                                                <li><a href="https://www.facebook.com/IndusRef/" target="_blank"  rel="noreferrer"><i className="fa fa-facebook" aria-hidden="true"></i></a></li>
                                                <li><a href="/"><i className="fa fa-twitter" aria-hidden="true"></i></a></li>
                                                <li><a href="/"><i className="fa fa-google-plus" aria-hidden="true"></i></a></li>
                                                <li><a href="/"><i className="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                            </ul>
                                        </div> */}
                                    </div>    
                                </div>
                            </div>
                        </div>    
                    </section> 
                    {/* <!--End footer bottom area-->   */}

                    {/* <!--Scroll to top--> */}
                    <div className="scroll-to-top scroll-to-target" data-target="html"><span className="fa fa-angle-up"></span></div>

       </>
    )
}

export default Footer;